import { Flags } from "@siteimprove/alfa-flags";
import { Parser } from "@siteimprove/alfa-parser";
import { Err, Result } from "@siteimprove/alfa-result";
import { Slice } from "@siteimprove/alfa-slice";
import { Token } from "../../syntax/index.js";
import { Keyword } from "../textual/keyword.js";
import { Value } from "../value.js";
const { doubleBar, mapResult } = Parser;
/**
 * {@link https://drafts.csswg.org/css-contain/#contain-property}
 */
const CFlags = Flags.named("contain", "size", "inline-size", "layout", "style", "paint");
/**
 * @public
 */
export class ContainFlags extends Value {
    static of(flags) {
        return new ContainFlags(flags);
    }
    _flags;
    constructor(flags) {
        super("contain-flags", false);
        this._flags = flags;
    }
    get size() {
        return this._flags.size;
    }
    get inlineSize() {
        return this._flags["inline-size"];
    }
    get layout() {
        return this._flags.layout;
    }
    get style() {
        return this._flags.style;
    }
    get paint() {
        return this._flags.paint;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return value instanceof ContainFlags && value._flags.equals(this._flags);
    }
    hash(hash) {
        hash.writeNumber(this._flags.value);
    }
    toJSON() {
        const { size, inlineSize, layout, style, paint } = this;
        return { ...super.toJSON(), size, inlineSize, layout, style, paint };
    }
    toString() {
        return this._flags.toString();
    }
}
/**
 * @public
 */
(function (ContainFlags) {
    function isContainFlags(value) {
        return value instanceof ContainFlags;
    }
    ContainFlags.isContainFlags = isContainFlags;
    ContainFlags.parse = mapResult(doubleBar(Token.parseWhitespace, Keyword.parse("size"), Keyword.parse("inline-size"), Keyword.parse("layout"), Keyword.parse("style"), Keyword.parse("paint")), (flags) => {
        if (flags.every((flag) => flag === undefined)) {
            return Err.of("Expected at least one contain flag");
        }
        if (flags[0] !== undefined && flags[1] !== undefined) {
            return Err.of("Cannot specify both `size` and `inline-size`");
        }
        return Result.of(ContainFlags.of(CFlags.of(...flags.map((flag) => flag?.value ?? 0))));
    });
})(ContainFlags || (ContainFlags = {}));
//# sourceMappingURL=contain.js.map